import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useLayoutBaseRepository, useLayoutPullRequestId} from '../stores/layout-selectors'

/**
 * Builds the models endpoint for the Manage batch "Fix with Copilot" picker.
 *
 * The endpoint belongs to the base repository for fork pull requests, and
 * `pull_id` is the numeric database id used to resolve the current model.
 */
export function useManageBatchModelPickerModelsUrl(): string | undefined {
  const pullRequestId = useLayoutPullRequestId()
  const baseRepository = useLayoutBaseRepository()

  if (!isFeatureEnabled('ccr_files_changed_model_picker')) return undefined

  return `/${baseRepository.ownerLogin}/${baseRepository.name}/copilot/coding_agent/models?pull_id=${pullRequestId}`
}
